<template>
	<div>
		<div class="font-weight-bold mb-2">
			Interesse von {{ applicantName }}
		</div>
		<div class="mb-3">{{ text }}</div>
		<JonInfo class="mb-3">
			<template #message>
				<div class="mb-3">
					Bitte leite die nächsten Schritte mit {{ applicantName }} ein.<br/>
					E-Mail Adresse und Telefonnummer wurden nun von {{ applicantName }} freigegeben. Diese findest du unter
					<b>Zusagen</b>.
				</div>
				<div>
					<b>Gratulation!</b>
				</div>
			</template>
		</JonInfo>
		<div class="text-right">
			<Button
				text="Schließen"
				icon="checkmark"
				@click="submit"
			/>
		</div>
	</div>
</template>

<script>
import * as Collaboration from "@/helper/communication/conversation/Collaboration"
import Button from "@/vue/common/Button";
import Reply, {ACTION_MARK_AS_READ} from "@/api/communication/conversation/message/Reply";
import flatten from "@/helper/error/Errors";
import * as Toast from "@/helper/layout/Toast";
import JonInfo from "@/vue/common/JonInfo.vue";

const TEXTS = {
	[Collaboration.INTEREST]: '%applicantName% hat das Interesse an Folgeschritten mitgeteilt.',
	[Collaboration.AGREEMENT_BASIC]: '%applicantName% hat Interesse an Folgeschritten bestätigt.',
	[Collaboration.PROMISE]: '%applicantName% hat aufgrund deiner Zusage ebenfalls die Zusage gesendet.',
	[Collaboration.AGREEMENT_FULL]: '%applicantName% hat aufgrund deiner Bestätigung ebenfalls die Zusage bestätigt.',
};

export default {

	components: {
		JonInfo,
		Button,
	},

	props: {
		message: {
			type: Object,
			required: true,
		},
	},

	data ()
	{
		return {
			sendingRequest: false,
		};
	},

	computed: {
		applicantName ()
		{
			return this.message.disclosedData.name;
		},
		text ()
		{
			const collaborationId = this.message.conversation.collaboration.id;

			return TEXTS[collaborationId].replaceAll('%applicantName%', this.applicantName);
		},
	},

	methods: {
		async submit ()
		{
			this.sendingRequest = true;

			try
			{
				const reply = new Reply()
					.setMessageId(this.message.id)
					.setAction(ACTION_MARK_AS_READ);

				await reply.call();

				this.$emit('processed');
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.sendingRequest = false;
		}
	}
}
</script>
